(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define("buildbot-travis", ["jquery"], factory);
	else if(typeof exports === 'object')
		exports["buildbot-travis"] = factory(require("jquery"));
	else
		root["buildbot-travis"] = factory(root["jquery"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6__) {
return 